import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import React, { useCallback, useEffect } from 'react';
import LoadingSpinner from '../../../../components/Loader/LoadingSpinner';
import useIframeOnload from '../../../../hooks/useIframeOnload';
import axios from '../../../../axios-default';
import Moment from 'moment/moment';
import { easySnackbar } from '../../../../store/Noti/noti.actions';
import { useDispatch } from 'react-redux';
import { useLang } from '../../../../util/lang';

const TrioIDesign = ({
    caseId,
    patientInfo,
    currentTreatmentPlan,
    iDesignTwoShowDownloadBtn,
    threeDimensionLink,
    useStyles,
    currentUserRole,
    isTopPositionNormal,
    sectionsCommonHeight,
    isShowSmileDesignFeature,
    switchTrioIDesignstyle = {},
    iframeStyle = {},
}) => {
    const get = useLang('PatientInfo');
    const dispatch = useDispatch();
    const classes = useStyles();

    const [downloading, setDownloading] = React.useState(false);
    const [threeDimensionLinkShow, setTreeDimensionLinkShow] = React.useState(false);

    const { iframeLoading, handleOnLoad } = useIframeOnload();

    const renderSimulation = React.useMemo(() => {
        if (patientInfo?.case_type && patientInfo?.case_type === 'RETAINER')
            return false;
        
        return patientInfo.isSmileDesign !== undefined;

        if (patientInfo.upsellType) {
            if (currentTreatmentPlan?.refinement_no && currentTreatmentPlan.refinement_no > 0) {
                return true;
            }
            return false;
        }
        return true;
    }, [
        patientInfo?.isSmileDesign,
        patientInfo?.case_type,
        isShowSmileDesignFeature,
        patientInfo?.upsellType,
        patientInfo.isSmileDesign,
        currentTreatmentPlan?.plan_id,
    ]);

    const downloadFile = async (event, file) => {
        const newIDesignLink = process.env.REACT_APP_IDESIGN_LINK;
        const isNewIDesignVersion = file.url.includes(newIDesignLink);
        if (isNewIDesignVersion) {
            try {
                const planId = file.plan_id;
                setDownloading(true);
                const downloadFileResp = await axios.get(`case/get_myo_download_url/${planId}`);
                const data = downloadFileResp.data;
                if (data.success) {
                    const link = document.createElement('a');
                    link.href = data.myo_download_url;
                    link.download = data.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            } catch (err) {
                let errorMessage = 'Cannot Download .myo file';
                if (err.response && err.response.data && err.response.data.message) {
                    errorMessage = err.response.data.message;
                }
                dispatch(easySnackbar(errorMessage, 'error'));
            }
            setDownloading(false);
        } else {
            const pid = file.myo_pid;
            setDownloading(true);
            let date = Moment().format('YYYY-MM-DD');
            axios.get(`case/download_myo/${pid}`, { responseType: 'blob' }).then(({ data }) => {
                let url = window.URL.createObjectURL(new Blob([data]));
                Object.assign(document.createElement('a'), { download: `${caseId}_${date}.myo`, href: url }).click();
                window.URL.revokeObjectURL(url);
                setDownloading(false);
            });
        }
    };

    useEffect(() => {
        setTreeDimensionLinkShow(threeDimensionLink);
    }, [threeDimensionLink]);

    const showDownloadButton =
        (currentTreatmentPlan.myo_url || iDesignTwoShowDownloadBtn) && ['ADMIN', 'SADMIN'].includes(currentUserRole);
    return (
        <Box
            style={{
                position: 'relative',
                height: sectionsCommonHeight,
                ...switchTrioIDesignstyle
            }}
        >
            {renderSimulation && threeDimensionLinkShow ? (
                <>
                    {iframeLoading && <LoadingSpinner />}
                    <iframe
                        title="3D Simulation"
                        id="ifrmbox"
                        src={threeDimensionLinkShow}
                        style={{
                            border: 'none',
                            width: showDownloadButton ? 'calc(100% - 126px)' : '100%',
                            // height: isTopPositionNormal
                            //     ? sectionsCommonHeight
                            //     : `calc(${sectionsCommonHeight} + 108.5px)`,
                            height: '100vh',
                            position: 'absolute',
                            left: showDownloadButton ? '126px' : 0,
                            top: isTopPositionNormal ? '0px' : '-108.5px',
                            ...iframeStyle,
                        }}
                        allow="clipboard-write"
                        onLoad={handleOnLoad}
                    ></iframe>
                </>
            ) : (
                <Box
                    style={{
                        backgroundColor: ' rgb(233, 233, 233)',
                        height: ' 100%',
                        display: ' grid',
                        placeContent: ' center',
                        fontSize: ' 16px',
                        color: ' gray',
                        fontWeight: ' 600',
                    }}
                >
                    No Treatment Plan
                </Box>
            )}

            {showDownloadButton && (
                <Box
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        zIndex: 1,
                        padding: '4px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Button onClick={async (e) => await downloadFile(e, currentTreatmentPlan)} variant="outlined">
                        Download
                    </Button>
                    {downloading && (
                        <CircularProgress
                            className={classes.progress}
                            color="secondary"
                            size={20}
                            style={{
                                margin: 10,
                            }}
                        />
                    )}
                </Box>
            )}
        </Box>
    );
};
export default TrioIDesign;
